import '../App.css';
import React,  {Alert,Component,PointerEvent} from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade,EffectCreative } from 'swiper';
import { Pagination, Navigation,Autoplay } from "swiper";
import { useRef, useState } from "react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';
import "swiper/css/effect-creative";
import { Nav,Navbar,Form,Button,Container,Row,Col,NavDropdown,Card,Modal} from 'react-bootstrap';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import YouTubeIcon from '@material-ui/icons/YouTube';
import MailIcon from '@material-ui/icons/Mail';
import CallIcon from '@material-ui/icons/Call';
import HouseIcon from '@material-ui/icons/House';
import AddIcon from '@material-ui/icons/Add';
import PersonIcon from '@material-ui/icons/Person';
import SearchIcon from '@material-ui/icons/Search';
import SendIcon from '@material-ui/icons/Send';
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import { BrowserRouter as Router, Switch, Route, Link,Redirect,HashRouter } from 'react-router-dom';
import Bounce from 'react-reveal/Bounce';
import Flip from 'react-reveal/Flip';
import Fade from 'react-reveal/Fade';
import Slide from 'react-reveal/Slide';
import Zoom from 'react-reveal/Zoom';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import Carousel from 'react-bootstrap/Carousel';
import { BrowserView, MobileView, isBrowser, isMobile} from "react-device-detect";
import queryString from 'query-string';
import { Rating } from 'react-simple-star-rating'
import Accordion from 'react-bootstrap/Accordion';
import CloseIcon from '@mui/icons-material/Close';
import { MapContainer , TileLayer, Circle, Tooltip, Popup,Marker,Polyline} from "react-leaflet";
import L from "leaflet";


const trajet_tour = [
  { id: 1, position: [-18.9386, 47.5272], name: "Antananarivo" }, // 1
];

const positionexotic = [-18.9386, 47.5272];
const initialZoom = 5;

const markerexotic = new L.icon({
  iconUrl: process.env.PUBLIC_URL + "marker-icon.png",
  iconSize: [25, 41],
  iconAnchor: [10, 41],
  popupAnchor: [2, -40]
});


const createCustomIcon = (number) => {
  return L.divIcon({
    html: `<div style="background: #3498db; color: white; border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; font-weight: bold;">${number}</div>`,
    iconSize: [24, 24],
    className: 'custom-icon'
  });
};

class Tours extends Component{
    
  constructor(props) {
  super(props);
    this.state = {
      loaddata : true,
      show: false,
      setShow: false,
      isModalVisible: false,
      isModalloderVisible : true,
      accueiltitre: '',
      accueilimage: '',
      touteslesarticles: [],
      touteslestours: [],
      listimage:[],
      listitinerary:[],
      idtourselect:0,
      title:'',
      description:'',
      roadmap:'',
      extensionfile:'',
      touteslesaccueil: [],
      touteslesgallery: [],
      gallery: [],
      allopinionuser:[],
      width: 0,
      height: 0,
      scrollpage:0,
      ratingvalue:5,
      ismodalinscription:false,
      avisdescription:'',
    };

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
      
  }
  
  async componentDidMount() {

    {/*//liste des articles
    const response = await fetch('https://mada-phototours.com/wbs/listtours/alltours.php');
    const data = await response.json();
  this.setState({ touteslesarticles: data})*/} 
    
    //liste des accueils
    const responseaccueil = await fetch('https://exotic-madagascar.com/wbs/accueil/allaccueil.php');
    const dataaccueil = await responseaccueil.json();
    this.setState({ touteslesaccueil: dataaccueil})
    
    //liste des gallery
    const responsegallery= await fetch('https://exotic-madagascar.com/wbs/gallery/allgallery.php');
    const datagallery = await responsegallery.json();
    this.setState({ touteslesgallery: datagallery}) 
  
    this.refreshgallery(datagallery) 

    //liste des tours
    const responsetours = await fetch('https://exotic-madagascar.com/wbs/tours/alltours.php');
    const datatours = await responsetours.json();
    this.setState({ touteslestours: datatours}) 
    
    

    //liste opinion
    const allopinion = await fetch('https://exotic-madagascar.com/wbs/users/selectopinion.php');
    const dataopinion = await allopinion.json();
    if(JSON.stringify(dataopinion).replace(/\"/g, "") !== '0'){
      this.setState({ allopinionuser: dataopinion})
    }
    
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    window.addEventListener('scroll', this.updateWindowDimensions);
      
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    window.removeEventListener('scroll', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight, scrollpage: window.scrollY });
  }

  scrolltop(){
    window.scrollTo(0, 0)
  }

  refreshgallery(datagallery){
    
    datagallery.forEach((item)=>{
      this.state.gallery.push({ original: process.env.PUBLIC_URL + './images/gallery/' + item.idgallery + '.' + item.extensionimage, thumbnail: process.env.PUBLIC_URL + './images/gallery/' + item.idgallery + '.' + item.extensionimage});
    })

    /*for (let i = 1; i < 21; i++) {

      if(i<10){
        this.state.gallery.push({ original: process.env.PUBLIC_URL + './images/gallerie/0' + i + '.jpg', thumbnail: process.env.PUBLIC_URL + './images/gallerie/0' + i + '.jpg'});
      }else{
        this.state.gallery.push({ original: process.env.PUBLIC_URL + './images/gallerie/' + i + '.jpg', thumbnail: process.env.PUBLIC_URL + './images/gallerie/' + i + '.jpg'});
      }
      
    }*/

  }

  reservation = (typetours) => { 

    window.location.href = "mailto:contact@exotic-madagascar.mg?Subject=Booking to " + typetours

  }

  selecttours(idtours,tourstitle,toursdescription,toursroadmap,extensionfile){

    this.setState({
      idtourselect: idtours,
      title:tourstitle,
      description:toursdescription,
      roadmap:toursroadmap,
      extensionimg: extensionfile,
      isModalVisible:true,
      listitinerary:[],
      listimage:[]
    })
  
    trajet_tour.length = 0;

    
    fetch(`https://exotic-madagascar.com/wbs/tours/gallerytours/selectimagetours.php`,{                  
          
    method:'post',
    headers: {'Content-Type':'application/x-www-form-urlencoded'},
    body: queryString.stringify({
      idtrs:idtours
    })

    })

    .then(response => response.json())
    .then(data => {

    if(JSON.stringify(data).replace(/\"/g, "") !== 'null'){

      this.setState({ 
        listimage:data, 
      })

    }

    })
    .catch(error => {
      this.setState({ tokenuser: error});
    });  


    fetch(`https://exotic-madagascar.com/wbs/tours/selectitinerarytour.php`,{                  
          
    method:'post',
    headers: {'Content-Type':'application/x-www-form-urlencoded'},
    body: queryString.stringify({
      idtrs:idtours
    })

    })

    .then(response => response.json())
    .then(dataitinerary => {

      
    if(JSON.stringify(dataitinerary).replace(/\"/g, "") !== 'null'){

      this.setState({ 
        listitinerary:dataitinerary, 
      })

      dataitinerary.forEach((item)=>{
        trajet_tour.push({ id:item.itinerary_day,position: [item.itinerary_latitude , item.itinerary_longitude],title:item.itinerary_title,description:item.itinerary_description});
      })


      

    }

    })
    .catch(error => {
      this.setState({ tokenuser: error});
    });  

  
      {/** 
     const responseitinerary = await fetch('https://exotic-madagascar.com/wbs/tours/selectitinerarytour.php',{                  
            method:'post',
            headers: {'Content-Type':'application/x-www-form-urlencoded'},
            body: queryString.stringify({
              idtrs:idtours 
            })});
      const dataitinerrary = await responseitinerary.json();
     
      if (Boolean(dataitinerrary) === true) {
         this.setState({ 
          listitinerary:dataitinerrary, 
        })
      }

       const response = await fetch('https://exotic-madagascar.com/wbs/tours/gallerytours/selectimagetours.php',{                  
          method:'post',
          headers: {'Content-Type':'application/x-www-form-urlencoded'},
          body: queryString.stringify({
            idtrs:idtours
          })});
        const data = await response.json();
      
        this.setState({
          listimage:data,
        })

        */}
          
  }

  addopinion(){

    if(this.state.nom.length == 0 && this.state.prenoms.length == 0) {

      alert("Please add your name or lastname.");
            
      return;

    }

    if (typeof(this.state.mail) == 'undefined') {

      alert("Please add your mail address.");
            
      return;

    }

    if (typeof(this.state.mail) !== undefined) {

        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);

        if (!pattern.test(this.state.mail)) {

            alert("Please write an exact mail address.");
            
            return;

        }
          
    }

    if(this.state.motdepasse.length < 8) {

      alert("Password must be minimum 8 characters.");
            
      return;

    }

    if(this.state.avisdescription.length == 0) {

      alert("Please add your rating description.");
            
      return;

    }

    fetch(`https://exotic-madagascar.com/wbs/users/addopinion.php`,{                  
            
          method:'post',
          headers: {'Content-Type':'application/x-www-form-urlencoded'},
          body: queryString.stringify({

            Nom: this.state.nom,
            Prenoms: this.state.prenoms,
            Email:this.state.mail,
            Motdepasse:this.state.motdepasse,
            avis : this.state.ratingvalue,
            descriptionavis : this.state.avisdescription,

          })

      })

      .then(response => response.json())
      .then(data => {

        if(JSON.stringify(data).replace(/\"/g, "") === 'User exist'){
          this.setState({ errorform: true, errormessage: 'User is exist.' });

          return;

        }

        if(JSON.stringify(data).replace(/\"/g, "") === 'Error insert'){
          this.setState({ errorform: true, errormessage: 'Error on server. Please repeat again.' });

          return;

        }

    
        if(JSON.stringify(data).replace(/\"/g, "") !== '0'){
          
          this.setState({ allopinionuser: data})
          
          this.setState({
            errorform: false,
            errormessage:'',
            nom:'',
            prenoms:'',
            mail:'',
            motdepasse:'',
            avis : "",
            ratingvalue:5,
            descriptionavis : "",
            avisdescription : "",
            ismodalinscription:false,
            //signin : true,
          });   
          
          alert("Your registration has been completed add your opinion has been add. You can log in to edit your profil.");

        }            
                  
      })

      .catch(error => {
            alert(error);
            this.setState({ tokenuser: error});
      });  

  }
  

  handlePointerMove = (value, index) => {
    this.setState({ ratingvalue: value}) 
  }

  render() {

      const onPointerMove = (value,index) => this.handlePointerMove(value, index)

        return (
            
              <div>

                    {this.state.scrollpage>200 ?

                        <Zoom>
                          <button className="bnttop" onClick={() => this.scrolltop()} style={{width:'50px', height:'50px', marginBottom:"70px",padding:"0%"}}><span><KeyboardDoubleArrowUpIcon /></span></button>
                        </Zoom>

                        :

                        null
                    
                    }

                    
                    <div>
    
                    <BrowserView>
                    <Modal
                      fullscreen
                            
                            show={this.state.isModalVisible}
                            onHide={ () => this.setState({isModalVisible:false,idtourselect: 0, title:'', description:'', roadmap:'', extensionimg: '',listimage:[]})}
                            dialogClassName="modal-dialog"
                            aria-labelledby="example-custom-modal-styling-title" centered
                        >
                        
                        <Modal.Body>
                            
                            <div className="d-flex flex-column">

                              <div style={{position:"fixed", right:'10px', top:10, zIndex: '1000'}}>
                                <button  className="btn btntransparent" onClick={() => this.setState({isModalVisible:false,idtourselect: 0, title:'', description:'', roadmap:'', extensionimg: '',listimage:[]})}><span style={{color:'#dc3545'}}><CloseIcon sx={{ width: '30px', height:'30px' }}/></span></button>
                              </div>

                              <Fade bottom>
                                <div className='align-items-center'>                         
                                    <p style={{color:"#3498db", fontWeight:"bold", fontSize:"2em", textAlign:'center', marginTop:'20px'}}>{this.state.title}&nbsp;</p>

                                </div>
                              </Fade>

                              <Fade bottom>
                                <div className='align-items-start'>                         
                                    <p style={{fontSize:'1rem', margin:"1rem"}}>{this.state.description}</p>

                                    {/*
                                    <div>
                                          
                                      <div dangerouslySetInnerHTML={{ __html: this.state.roadmap }}></div> 
                                        
                                    </div>
                                    */}
                                </div>
                              </Fade>

                              {this.state.listitinerary.length>0 ?
        
                                    <div>

                                      <Fade zoom>
                                        <div className='align-items-center'>                         
                                            <p style={{color:"black", fontWeight:"bold", fontSize:"1.5em", textAlign:'center', marginTop:'20px'}}>Itinerary</p>

                                        </div>
                                      </Fade>

                                      <Accordion>
        
                                      {this.state.listitinerary.map((iti) => {
        
                                      return (
        
                                            <Accordion.Item eventKey={parseInt(iti.iditinerary)}>
                                              <Accordion.Header><span style={{fontWeight:"bold"}}>Day {parseInt(iti.itinerary_day)}:</span> &nbsp;{iti.itinerary_title}</Accordion.Header>
                                              <Accordion.Body>
                                                <p>{iti.itinerary_description}</p>
                                                {iti.itinerary_image !== null?

                                                  <div className='d-flex justify-content-center align-items-center'>
                                                  <img
                                                    style={{width:"730px",height:"500px", marginTop:"0px", borderRadius:"10px"}}
                                                    src={process.env.PUBLIC_URL + './images/tours/itinerarytours/' + iti.itinerary_image}
                                                  />
                                                  </div>
                                              
                                                  :

                                                  null

                                                }
                                                
                                              </Accordion.Body>
                                            </Accordion.Item>
        
                                        );
                                      })} 

                                      </Accordion>
        
                                    </div>
        
                                    :
        
                                    null
        
                                  }

                            
                              

                               

                                  {this.state.listimage.length>0 ?

                                 

                                    <Fade zoom>
                                      <div className='align-items-center'>                         
                                          <p style={{color:"black", fontWeight:"bold", fontSize:"1.5em", textAlign:'center', marginTop:'40px'}}>Gallery</p>

                                      </div>
                                   
                                       <div style={{ display: 'flex', justifyContent: 'center' }}>
                                      <Carousel style={{width:"730px",height:"500px"}}>
        
                                      {this.state.listimage.map((lst) => {
        
                                      return (
        
                                            <Carousel.Item key={lst.idimagestours} interval={3000}>
                                          
                                              <img
                                                style={{width:"730px",height:"500px", marginTop:"0px", borderRadius:"10px"}}
                                                src={process.env.PUBLIC_URL + './images/tours/gallerytours/' + lst.idimagestours + '.' + lst.extensionimage}
                                              />
                                                                                          
                                            </Carousel.Item>
        
                                        );
                                      })} 
        
                                      </Carousel>
                                      </div>

                                     </Fade>

                                    :
                                        <div style={{ display: 'flex', justifyContent: 'center', marginTop:"40px"}}>
                                          <img
                                              style={{width:"730px",height:"500px", marginTop:"0px", borderRadius:"10px"}}
                                              src={process.env.PUBLIC_URL + './images/tours/' + this.state.idtourselect + '.' + this.state.extensionimg}
                                            />
                                        </div>
        
                                  }

                                {this.state.listitinerary.length>0 ?

                                <div>

                                 <Fade bottom>
                                  <div className='align-items-center'>                         
                                      <p style={{color:"black", fontWeight:"bold", fontSize:"1.5em", textAlign:'center', marginTop:'40px'}}>Tour circuit</p>

                                  </div>
                                </Fade>

                                <div className='d-flex justify-content-center align-items-center'>

                                  <MapContainer
                                    center={positionexotic}
                                    zoom={initialZoom}
                                    style={{width:"730px",height:"500px", marginBottom:"50px",zIndex:10000}}
                                  >

                                    {trajet_tour.length>0?
                                    
                                    <div>

                                    <TileLayer
                                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                    {trajet_tour.map((point) => (
                                        <Marker
                                          key={point.id}
                                          position={point.position}
                                          icon={createCustomIcon(point.id)}
                                        
                                        >
                                          <Popup><span style={{fontWeight:"bold"}}>{point.title}</span>:<br/>{point.description}</Popup>
                                        </Marker>
                                      ))}

                                    <Polyline
                                      positions={trajet_tour.map((point) => point.position)}
                                      color="#5cb85c"
                                      weight={3}
                                    />

                                    </div>

                                    :

                                    null
                                    
                                    
                                    }

                                  </MapContainer>

                                </div>

                              </div>

                              :

                              null
                              
                              }

                                <div style={{position:"fixed", right:'40px', bottom:50, zIndex: '1000'}}>
                                    <Button className="btn btn-warning " style={{ marginLeft:"360px",marginTop:"40px"}} onClick={() => this.reservation(this.state.title)} variant="primary">Book it</Button>
                                </div>
                                {/*
                                
                                    <div className="d-flex flex-column" style={{margin:"20px"}}>
                                        
                                        <div className="d-flex flex-column">
                                            <p style={{fontWeight:"bold", textAlign:'center'}}>{this.state.title}&nbsp;</p>
                                            <p style={{maxHeight:"12rem",overflowX:"auto"}}>{this.state.description}</p>
                                        </div>
                                        
                                    <div>
                                        <div className="d-flex flex-column" style={{overflow:"auto", height:'260px', width:'600px',maxHeight:"12rem",overflowX:"auto"}}> 
                                          <div dangerouslySetInnerHTML={{ __html: this.state.roadmap }}></div>           
                                        </div>
                                        
                                    </div>
                                    
                                    <div className="d-flex flex-row" style={{marginTop:"20px", marginBottom:"20px"}}>
                                            <div style={{fontWeight:"bold"}}>Price :&nbsp;</div>
                                            <div>500 € </div>
                                    </div>
                                                                        
                                    <div className='row text-white d-flex align-items-center'>
                                        <div style={{marginBottom:"-20px", position:"fixed"}}>
                                            <Button className="btn "style={{ marginLeft:"16px",marginTop:"40px"}} onClick={() => this.setState({isModalVisible:false,idtourselect: 0, title:'', description:'',  roadmap:'',  extensionimg: '',listimage:[]})} variant="primary">Close</Button>
                                            <Button className="btn btn-warning " style={{ marginLeft:"360px",marginTop:"40px"}} onClick={() => this.reservation(this.state.title)} variant="primary">Book it</Button>
                                        </div>
                                        
                                    </div>
    
                                    </div>

                                    */}
    
                            </div>    
    
                        </Modal.Body>
                        </Modal>
                    </BrowserView>
    
                    <MobileView >
    
                    <Modal
                      fullscreen
                            
                            show={this.state.isModalVisible}
                            onHide={ () => this.setState({isModalVisible:false,idtourselect: 0, title:'', description:'', roadmap:'', extensionimg: '',listimage:[]})}
                            dialogClassName="modal-dialog"
                            aria-labelledby="example-custom-modal-styling-title" centered
                        >
                        
                        <Modal.Body>


                          <div className="d-flex flex-column">

                              <div style={{position:"fixed", right:'10px', top:10, zIndex: '1000'}}>
                                <button  className="btn btntransparent" onClick={() => this.setState({isModalVisible:false,idtourselect: 0, title:'', description:'', roadmap:'', extensionimg: '',listimage:[]})}><span style={{color:'#dc3545'}}><CloseIcon sx={{ width: '30px', height:'30px' }}/></span></button>
                              </div>

                              <Fade bottom>
                                <div className='align-items-center'>                         
                                    <p style={{color:"#3498db", fontWeight:"bold", fontSize:"1.5em", textAlign:'center', marginTop:'20px'}}>{this.state.title}&nbsp;</p>

                                </div>
                              </Fade>

                              <Fade bottom>
                                <div className='align-items-start'>                         
                                    <p style={{fontSize:'1rem', margin:"1rem"}}>{this.state.description}</p>

                                    {/*
                                    <div>
                                          
                                      <div dangerouslySetInnerHTML={{ __html: this.state.roadmap }}></div> 
                                        
                                    </div>
                                    */}
                                </div>
                              </Fade>

                              {this.state.listitinerary.length>0 ?
        
                                    <div>

                                      <Fade zoom>
                                        <div className='align-items-center'>                         
                                            <p style={{color:"black", fontWeight:"bold", fontSize:"1.5em", textAlign:'center', marginTop:'20px'}}>Itinerary</p>

                                        </div>
                                      </Fade>

                                      <Accordion>
        
                                      {this.state.listitinerary.map((iti) => {
        
                                      return (
        
                                            <Accordion.Item eventKey={parseInt(iti.iditinerary)}>
                                              <Accordion.Header><span style={{fontWeight:"bold"}}>Day {parseInt(iti.itinerary_day)}:</span> &nbsp;{iti.itinerary_title}</Accordion.Header>
                                              <Accordion.Body>
                                                <p>{iti.itinerary_description}</p>
                                                {iti.itinerary_image !== null?

                                                  <div className='d-flex justify-content-center align-items-center'>
                                                  <img
                                                    className="d-block w-100" style={{width:"90%", height:"14rem", resizeMode:"contain", borderRadius:"10px"}}  alt='Mada Photo Tours' 
                                                    src={process.env.PUBLIC_URL + './images/tours/itinerarytours/' + iti.itinerary_image}
                                                  />
                                                  </div>
                                              
                                                  :

                                                  null

                                                }
                                                
                                              </Accordion.Body>
                                            </Accordion.Item>
        
                                        );
                                      })} 

                                      </Accordion>
        
                                    </div>
        
                                    :
        
                                    null
        
                                  }


                                  {this.state.listimage.length>0 ?

                                    <Fade zoom>
                                      <div className='align-items-center'>                         
                                          <p style={{color:"black", fontWeight:"bold", fontSize:"1.5em", textAlign:'center', marginTop:'40px'}}>Gallery</p>

                                      </div>
                                   
                                       <div style={{ display: 'flex', justifyContent: 'center' }}>
                                      <Carousel style={{width:"90%", height:"14rem"}}>
        
                                      {this.state.listimage.map((lst) => {
        
                                      return (
        
                                            <Carousel.Item key={lst.idimagestours} interval={3000}>
                                          
                                              <img
                                                 className="d-block w-100" style={{width:"90%", height:"14rem", resizeMode:"contain", borderRadius:"10px"}}  alt='Mada Photo Tours' 
                                                src={process.env.PUBLIC_URL + './images/tours/gallerytours/' + lst.idimagestours + '.' + lst.extensionimage}
                                              />
                                                                                          
                                            </Carousel.Item>
        
                                        );
                                      })} 
        
                                      </Carousel>
                                      </div>

                                     </Fade>

                                    :
                                        <div style={{ display: 'flex', justifyContent: 'center', marginTop:"0px"}}>
                                          <img
                                              className="d-block w-100" style={{width:"90%", height:"14rem", resizeMode:"contain", borderRadius:"10px"}}  alt='Mada Photo Tours' 
                                              src={process.env.PUBLIC_URL + './images/tours/' + this.state.idtourselect + '.' + this.state.extensionimg}
                                            />
                                        </div>
        
                                  }

                                {this.state.listitinerary.length>0 ?

                                <div>

                                 <Fade bottom>
                                  <div className='align-items-center'>                         
                                      <p style={{color:"black", fontWeight:"bold", fontSize:"1.5em", textAlign:'center', marginTop:'40px'}}>Tour circuit</p>

                                  </div>
                                </Fade>

                                <div className='d-flex justify-content-center align-items-center'>

                                  <MapContainer
                                    center={positionexotic}
                                    zoom={initialZoom}
                                    style={{width:"100%",height:"30vh", marginBottom:"50px",marginTop:"0px",zIndex:1}}
                                  >

                                    {trajet_tour.length>0?
                                    
                                    <div>

                                    <TileLayer
                                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                    {trajet_tour.map((point) => (
                                        <Marker
                                          key={point.id}
                                          position={point.position}
                                          icon={createCustomIcon(point.id)}
                                        
                                        >
                                          <Popup><span style={{fontWeight:"bold"}}>{point.title}</span>:<br/>{point.description}</Popup>
                                        </Marker>
                                      ))}

                                    <Polyline
                                      positions={trajet_tour.map((point) => point.position)}
                                      color="#5cb85c"
                                      weight={3}
                                    />

                                    </div>

                                    :

                                    null
                                    
                                    
                                    }

                                  </MapContainer>

                                </div>

                              </div>

                              :

                              null
                              
                              }

                                <div style={{position:"fixed", right:'40px', bottom:50, zIndex: '1000'}}>
                                    <Button className="btn btn-warning " style={{ width:"80px",marginLeft:"360px",marginTop:"40px"}} onClick={() => this.reservation(this.state.title)} variant="primary">Book it</Button>
                                </div>
                                
    
                            </div>    
        
                        </Modal.Body>
                        </Modal>
    
                    </MobileView>

                    </div>
                    
          
                    <div id="tours" >
                        
                        <Fade bottom>
                          <div className='align-items-center'>                         
                              <p style={{color:"black", fontWeight:"bold", fontSize:"2em", textAlign:'center', marginTop:'80px'}}>Travel Tours</p>

                          </div>
                        </Fade>

                        
                        

                        <BrowserView>
                          <div className='listedata'>
                            {this.state.touteslestours.map((tours) => {
                              return (

                                  <div >

      
                                      <Fade bottom>
                                        <div key={tours.idtours} className="cardlist" style={{}}>
                                          <div className="row">

                                            <div className="col">

                                                <img variant="top" src={process.env.PUBLIC_URL + './images/tours/' + tours.idtours + '.jpg'} style={{width:"24rem", height:"16rem", marginTop:"1rem", marginLeft:"1rem",resizeMode:"contain"}} className="rounded float-left" alt='Mada Photo Tours'/>

                                            </div>

                                            <div className="col" style={{width:"25rem", height:"18rem",maxHeight:"18rem"}}>

                                                    <p style={{marginTop:"1rem", fontSize:"1.5rem", fontWeight:"bold", textAlign:"center"}}>{tours.titletours}</p>
                                                    <p style={{fontSize:'1rem', margin:"1rem",maxHeight:"6rem",overflowX:"auto"}}>{tours.descriptiontours}</p>
                                                    
                                                    <div className='align-items-center'>
                                                        
                                                        <button className="buttondetails" style={{width:'100px', margin:"1rem",marginTop:"-1rem"}} onClick={() => this.selecttours(tours.idtours,tours.titletours,tours.descriptiontours,tours.roadmaptours,tours.extensionimage)} >ABOUT</button>
                                                        
                                                    </div>
                                            </div>

                                          </div>
                                        </div>
                                      </Fade>
          
                                                                    
                                  </div>

                                );
                            })}

                          </div>

                        </BrowserView>

                        <MobileView>
                          <div className='listedatamobile justify-content-center'>
                            {this.state.touteslestours.map((tours) => {
                              return (

                                  <div >

      
                                        <Fade bottom>
                                          <div key={tours.idtours} className="cardlistmobile" >
                                            <div className="column">

                                            

                                                  <img variant="top" src={process.env.PUBLIC_URL + './images/tours/' + tours.idtours + '.jpg'} style={{width:"90%", height:"16rem", margin:"1rem",resizeMode:"contain", borderRadius:"10px"}}  alt='Mada Photo Tours'/>

                                              

                                              <div style={{width:"100%", height:"18rem"}}>

                                                      <p style={{marginTop:"1rem", fontSize:"1.5rem", fontWeight:"bold", textAlign:"center"}}>{tours.titletours}</p>
                                                      <p style={{fontSize:'1rem', margin:"1rem",maxHeight:"6rem",overflowX:"auto"}}>{tours.descriptiontours}</p>
                                                      
                                                      <div className='align-items-center'>
                                                          
                                                          <button className="buttondetails" style={{width:'100px', margin:"1rem"}} onClick={() => this.selecttours(tours.idtours,tours.titletours,tours.descriptiontours,tours.roadmaptours,tours.extensionimage)} >ABOUT</button>
                                                          
                                                      </div>
                                              </div>

                                            </div>
                                          </div>
                                        </Fade>
          
                                                                    
                                  </div>

                                );
                            })}
                          </div>
                        </MobileView>
                    </div> 

                    <BrowserView>

                      <div id="contact" className="justify-content-center footer" style={{marginTop:'60px'}}>

                        <div className="container">

                        <div className="container">
                          <div className="row">
                            <Fade left>
                            <div className="col">
                              <p style={{color:"white", fontWeight:"bold", fontSize:"1.5em", marginTop:'20px'}}>Contact</p>
                              
                              {/*
                              <div className="contactlist'">  
                                  <a href="tel:+000000000" target="_blank"><CallIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="tel:+000000000" target="_blank"></a>
                              </div>
                              */}

                              <div className="contactlist'">  
                                  <a href="mailto:contact@exotic-madagascar.com" target="_blank"><MailIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="mailto:contact@exotic-madagascar.com" target="_blank">resa@exotic-madagascar.mg</a>
                              </div>
                              
                              {/*
                              <div className="contactlist'">  
                                  <a href="mailto:armeltourguide@gmail.com" target="_blank" rel="noopener noreferrer"><MailIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="mailto:armeltourguide@gmail.com" target="_blank" rel="noopener noreferrer">Mail to the guide</a>
                              </div>
                              */}

                              <div className="contactlist'">  
                                  <a href="https://facebook.com/ArmelMadagascar" target="_blank"><SendIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="tel:+000000000" target="_blank">Antananarivo 101</a>
                              </div>

                            </div>
                            </Fade>

                            <Fade right>
                            <div className="col">
                              <p style={{color:"white", fontWeight:"bold", fontSize:"1.5em", marginTop:'20px'}}>Support</p>
                              <div className="contactlist'">  
                                  <a href="https://facebook.com/ArmelMadagascar" target="_blank"><FacebookIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="https://facebook.com/ArmelMadagascar" target="_blank">Exotic Madagascar</a>
                              </div>

                              <div className="contactlist'">  
                                  <a href="https://linkedin.com/in/exoticmadagascar" target="_blank"><LinkedInIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="https://linkedin.com/in/exoticmadagascar" target="_blank">Exotic Madagascar</a>
                              </div>

                              <div className="contactlist'">  
                                  <a href="https://youtube.com/user/exoticmadagascar" target="_blank"><YouTubeIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="https://youtube.com/user/exoticmadagascar" target="_blank">Exotic Madagascar</a>
                              </div>
                            </div>
                            </Fade>
                            
                          </div>

                        </div>

                          <Zoom>

                            <div className="row">
                                <div className="text-center">
                                    
                                    <div className="py-1">
                                        <a href="https://web.facebook.com/ArmelMadagascar" target="_blank"><FacebookIcon style={{fontSize:'40' , color: '#3498db', margin:10}}/></a>
                                        <a href="https://linkedin.com/in/exoticmadagascar" target="_blank" ><LinkedInIcon style={{fontSize:'40', color: '#3498db', margin:10}}/></a>
                                        <a href="https://youtube.com/user/exoticmadagascar" target="_blank"><YouTubeIcon style={{fontSize:'40', color: '#3498db', margin:10}}/></a>
                                    </div>
                                </div>
                            </div>

                            <div className="text-center">
                                <div className="py-1">

                                    <p className="textombrenoir" style={{ color:'white',fontSize:"20px"}}>
                                      Copyright &copy; {new Date().getFullYear()} Tous les droits réservés à Exotic Madagascar.
                                    </p>
                                                                                      
                                </div>
                            </div>

                          </Zoom>

                        </div>

                        </div>

                    </BrowserView>

                    <MobileView>

                      <div id="contact" className="justify-content-center footer" style={{marginTop:"10px"}}>

                        <div className="container">

                        <div className="container">
                          <div className="column">
                            <Fade left>
                            <div className="col">
                              <p style={{color:"white", fontWeight:"bold", fontSize:"1.5em"}}>Contact</p>
                              {/* 
                              <div className="contactlist'">  
                                  <a href="tel:+000000000" target="_blank"><CallIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="tel:+000000000" target="_blank"></a>
                              </div>
                              */}

                              <div className="contactlist'">  
                                  <a href="mailto:contact@exotic-madagascar.com" target="_blank"><MailIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="mailto:contact@exotic-madagascar.com" target="_blank">resa@exotic-madagascar.mg</a>
                              </div>

                              {/*
                              <div className="contactlist'">  
                                  <a href="mailto:armeltourguide@gmail.com" target="_blank"><MailIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="mailto:armeltourguide@gmail.com" target="_blank">Mail to the guide</a>
                              </div>
                              */}

                              <div className="contactlist'">  
                                  <a href="https://facebook.com/ArmelMadagascar" target="_blank"><SendIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="tel:+000000000" target="_blank">Antananarivo 101</a>
                              </div>
                              
                            </div>
                            </Fade>

                            <Fade right>
                            <div className="col">
                              <p style={{color:"white", fontWeight:"bold", fontSize:"1.5em", marginTop:'20px'}}>Support</p>
                              <div className="contactlist'">  
                                  <a href="https://facebook.com/ArmelMadagascar" target="_blank"><FacebookIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="https://facebook.com/ArmelMadagascar" target="_blank">Exotic Madagascar</a>
                              </div>

                              <div className="contactlist'">  
                                  <a href="https://linkedin.com/in/exoticmadagascar" target="_blank"><LinkedInIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="https://linkedin.com/in/exoticmadagascar" target="_blank">Exotic Madagascar</a>
                              </div>

                              <div className="contactlist'">  
                                  <a href="https://youtube.com/user/exoticmadagascar" target="_blank"><YouTubeIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/></a>
                                  <a href="https://youtube.com/user/exoticmadagascar" target="_blank">Exotic Madagascar</a>
                              </div>
                            </div>
                            </Fade>
                            
                          </div>

                        </div>

                          <Zoom>

                            <div className="row">
                                <div className="text-center">
                                    
                                    <div className="py-1">
                                        <a href="https://web.facebook.com/theharmelsmadagascar" target="_blank"><FacebookIcon style={{fontSize:'40' , color: '#3498db', margin:10}}/></a>
                                        <a href="https://linkedin.com/in/madaphototours" target="_blank" ><LinkedInIcon style={{fontSize:'40', color: '#3498db', margin:10}}/></a>
                                        <a href="https://youtube.com/user/madaphototours" target="_blank"><YouTubeIcon style={{fontSize:'40', color: '#3498db', margin:10}}/></a>
                                    </div>
                                </div>
                            </div>

                            <div className="text-center">
                                <div className="py-1">

                                    <p className="textombrenoir" style={{ color:'white',fontSize:"20px"}}>
                                      Copyright &copy; {new Date().getFullYear()} Tous les droits réservés à Exotic Madagascar.
                                    </p>
                                                                                      
                                </div>
                            </div>

                          </Zoom>

                        </div>

                        </div>

                    </MobileView>
                   

              </div>
        );
      }
  
}

export default Tours;
